import React from 'react';
import { ApplicationList } from 'components/ApplicationList';

export const Applications = () => {
  return (
    <div>
      <div>{<ApplicationList />}</div>
    </div>
  );
};
